import type {MRT_ColumnDef} from 'mantine-react-table';
import {useMemo} from 'react';
import type {ProjectSimpleResponse} from 'src/api/ProactApiClient';
import {Pill} from 'src/design/atoms/Pill';
import {ActiveInactivePills} from 'src/shared/constants/PillConstants';
import {ActiveStateDataOptions} from 'src/shared/constants/columnFilterData';

export const useProjectColumns = () => {
  const columns = useMemo<MRT_ColumnDef<ProjectSimpleResponse>[]>(
    () => [
      {
        accessorKey: 'name',
        header: 'Name',
      },
      {
        accessorKey: 'code',
        header: 'Code',
        size: 120,
      },
      {
        accessorKey: 'region.name',
        header: 'Region',
      },
      {
        accessorKey: 'address',
        header: 'Address',
      },
      {
        accessorKey: 'city',
        header: 'City',
      },
      {
        accessorKey: 'state',
        header: 'State / Province',
      },
      {
        accessorKey: 'active',
        header: 'Active',
        enableColumnFilterModes: false,
        filterVariant: 'multi-select',
        mantineFilterSelectProps: {
          data: ActiveStateDataOptions,
        },
        Cell: ({cell}) => {
          const cellValue = cell.getValue<boolean | undefined>();
          const pillConfig = ActiveInactivePills(cellValue);
          return <Pill text={pillConfig.text} color={pillConfig.color} />;
        },
      },
    ],
    []
  );

  return columns;
};
